import { ArrayPoint, Point, SeriesType } from '../modules/components/cartesian';
import { parseDateTime } from '../utils';

const mapPoint = (point: Point): Point => ({
  ...point,
  x: parseDateTime(point.x),
});

const mapArrayPoint = (point: ArrayPoint): ArrayPoint => {
  const x = parseDateTime(point[0]);
  const values = point.slice(1);
  return [x, ...values] as ArrayPoint;
};

/**
 * Converts ISO timestamp in points to Unix timestamp
 * @param series series with array or object points
 * @returns series with timestamps converted to numbers
 */
export const toDataTimeSeries = (series: SeriesType): SeriesType => {
  try {
    return {
      ...series,
      ...(series?.data
        ? {
            data: series.data.map(point =>
              Array.isArray(point) ? mapArrayPoint(point as ArrayPoint) : mapPoint(point as Point),
            ),
          }
        : {}),
    } as SeriesType;
  } catch (e) {
    return series;
  }
};
